export enum MessageState {
  UNDEFINED = 'undefined',
  SENDING = 'sending',
  INTERMIEDIARY = 'intermediary',
  RECEIVED = 'received',
  ERROR = 'error',
}